/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundDto } from '../../models/backend-own-fund-dto';
import { BackendOwnFundRequestDto } from '../../models/backend-own-fund-request-dto';

export interface FinancingSourcesOwnFundsUpdate$FormData$Params {
  /**
   * A unique integer value identifying this own fund.
   */
  id: number;
  body: BackendOwnFundRequestDto;
}

export function financingSourcesOwnFundsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesOwnFundsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOwnFundDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOwnFundDto>;
    }),
  );
}

financingSourcesOwnFundsUpdate$FormData.PATH = '/api/financing_sources/own_funds/{id}/';
